import React from "react";
import intl from "react-intl-universal";
import styled from "styled-components";

const NotFoundStyle = styled.div`
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme.white};
    background-color: ${props => props.theme.primaryDark};
`;

export const NotFound = () => <NotFoundStyle>{intl.get("common.notFound")}</NotFoundStyle>;